<template>
    <div class="chat-container">
        <div class="chat-title">智能体辅助</div>
        <div class="chat-messages" ref="chatBox">

            <div v-for="(msg, index) in messages" :key="index" :class="msg.role">
                <div v-for="(segment, i) in parseMessage(msg.content)" :key="i">
                    <div v-if="segment.type === 'text'" class="msg-bubble">{{ segment.content }}</div>
                    <div v-else-if="segment.type === 'think'" class="think-bubble">🧠 {{ segment.content }}</div>
                </div>
            </div>

        </div>
        <div class="chat-input">
            <el-input v-model="input" placeholder="请输入消息" @keyup.enter="sendMessage" clearable />
            <el-button type="primary" @click="sendMessage">发送</el-button>
            <el-button type="danger" @click="stopStreaming" :disabled="!isLoading">
                停止生成
            </el-button>
        </div>
    </div>
</template>

<script setup>
import { ref, nextTick } from 'vue'
import axios from 'axios'
import { reactive } from 'vue'

const input = ref('')
const messages = ref([
    { role: 'assistant', content: '我是右脑的智能问答，你可以叫我达芬奇，有什么可以帮助你？' }
])

const isLoading = ref(false)
const controller = new AbortController()

const scrollToBottom = () => {
    nextTick(() => {
        const box = document.querySelector('.chat-messages')
        if (box) box.scrollTop = box.scrollHeight
    })
}

const stopStreaming = () => {
    controller.abort()
    isLoading.value = false
}

const parseMessage = (text) => {
    const result = []
    const regex = /<think>(.*?)<\/think>/gs
    let lastIndex = 0
    let match

    while ((match = regex.exec(text)) !== null) {
        const [fullMatch, thinkContent] = match
        const start = match.index

        if (start > lastIndex) {
            result.push({
                type: 'text',
                content: text.slice(lastIndex, start)
            })
        }

        result.push({
            type: 'think',
            content: thinkContent.trim()
        })

        lastIndex = start + fullMatch.length
    }

    if (lastIndex < text.length) {
        var content = text.slice(lastIndex)
        // console.log(content)
        if (content.startsWith("\n\n")) {
            content = content.slice(2)
        }
        // console.log(content)
        result.push({
            type: 'text',
            content: content
        })
    }
    return result
}

const sendMessage = async () => {
    const text = input.value.trim()
    if (!text) return

    messages.value.push({ role: 'user', content: text })
    input.value = ''
    scrollToBottom()

    // 加载中状态
    // messages.value.push({ role: 'assistant', content: '正在思考中...' })

    const newMsg = reactive({ role: 'assistant', content: '<think>正在思考中...' })
    messages.value.push(newMsg)
    isLoading.value = true

    try {
        const response = await fetch(
            process.env.VUE_APP_MCP_URL, {
            method: 'POST',
            body: JSON.stringify({
                question: text,
                k: 5
            }),
            headers: { 'Content-Type': 'application/json' },
            signal: controller.signal
        })
        // 替换 loading 文本
        // messages.value.pop()

        if (!response.ok) throw new Error('响应失败')
        const result = await response.json()
        // 假设返回格式为 { choices: [{ message: { content: "xxx" } }] }
        console.log(result)
        const content = result || '[无内容返回]'
        newMsg.content = content
    } catch (err) {
    if (err.name === 'AbortError') {
        newMsg.content += '【已手动终止生成】'
    } else {
        console.error('请求出错:', err)
        newMsg.content = '[出错了，请重试]'
    }
} finally {
    isLoading.value = false
    scrollToBottom()
}
}
</script>

<style scoped>
.chat-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    /* 占满整个浏览器视口高度 */
    padding: 16px;
    box-sizing: border-box;
}

.chat-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 12px;
    flex-shrink: 0;
}

.chat-messages {
    flex: 1;
    overflow-y: auto;
    padding: 10px;
    background: #f4f4f4;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 12px;
    box-sizing: border-box;
}

.user {
    text-align: right;
    margin: 8px 0;
}

.assistant {
    text-align: left;
    display: block;
    margin: 8px 0;
}

.msg-bubble {
    display: inline-block;
    padding: 8px 12px;
    margin: 6px 0;
    border-radius: 10px;
    max-width: 70%;
    background-color: #e0f3ff;
    word-break: break-word;
}

.user .msg-bubble {
    background-color: #cce5ff;
}

.think-bubble {
    background-color: #f9f9f9;
    color: #6c757d;
    padding: 6px 10px;
    margin: 4px 0;
    border-left: 4px solid #aaa;
    font-style: italic;
    font-size: 14px;
    border-radius: 4px;
    max-width: 70%;
}

.assistant .msg-bubble {
    background-color: #e6f4ea;
    /* 或 #d2eaf3 / #eaf4fe 也行 */
    color: #222;
    white-space: pre-wrap;
    /* 保留换行 */
}

.chat-input {
    display: flex;
    gap: 8px;
    align-items: center;
}

.chat-input :deep(.el-input) {
    flex: 1;
}

.ai-think {
    color: #8a2be2;
    background-color: #f3e8ff;
    padding: 2px 4px;
    border-radius: 4px;
    font-style: italic;
}
</style>